import { createGlobalStyle } from 'styled-components';
import './index.css';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font: 13px "Graphik", Arial, sans-serif;
  }

  .content {
      display: grid;
      grid-template-rows: auto 1fr auto;
      grid-template-areas:
      "header"
      "main"
      "footer";
      height: 100vh;
  }

header {
    grid-area: header;
  }

main {
  grid-area: main;
}

footer {
  grid-area: footer;
}

input[type='text'],
input[type='number'],
select {
  border: 1px solid lightgray;
  border-radius: 4px;
}

`;

export default GlobalStyle;
